import React, { useState, useEffect } from 'react';
import BoatsBulkDeleteModal from './BoatsBulkDeleteModal';

const BoatsBulkActions = ({ 
  selectedBoats, 
  clearSelectedBoats, 
  loadBoats 
}) => {
  const [bulkAction, setBulkAction] = useState('');
  const [isBulkDeleteModalOpen, setIsBulkDeleteModalOpen] = useState(false);

  useEffect(() => {
    if (selectedBoats.length === 0) {
      setBulkAction('');
    }
  }, [selectedBoats]);

  const handleBulkAction = async () => {
    if (!selectedBoats.length) {
      alert('No boats selected.');
      return;
    }

    if (bulkAction === 'delete') {
      setIsBulkDeleteModalOpen(true);
    }
  };

  return (
    <div className="bulk-actions-container">
      <select
        className="bulk-actions-select"
        value={bulkAction}
        onChange={(e) => setBulkAction(e.target.value)}
        style={{
          backgroundColor: selectedBoats.length > 0 ? '#f8f8f8' : '#f2f2f2',
          color: selectedBoats.length > 0 ? '#000' : '#999',
        }}
      >
        <option value="">Bulk Actions</option>
        <option value="delete">Delete</option>
      </select>
      <button
        className="button secondary"
        onClick={handleBulkAction}
        disabled={!bulkAction || selectedBoats.length === 0}
      >
        Apply
      </button>

      <BoatsBulkDeleteModal
        isOpen={isBulkDeleteModalOpen}
        onClose={() => {
          setIsBulkDeleteModalOpen(false);
          clearSelectedBoats();
        }}
        onSuccess={() => {
          loadBoats();
          setIsBulkDeleteModalOpen(false);
          clearSelectedBoats();
          setBulkAction('');
        }}
        boats={selectedBoats}
      />
    </div>
  );
};

export default BoatsBulkActions;